import { loadingController, type LoadingOptions } from '@ionic/vue';

export const isLoading = ref(false);

export async function showLoading(message: string, duration?: number): Promise<HTMLIonLoadingElement> {
  isLoading.value = true;
  
  const options: LoadingOptions = {
    message,
    spinner: 'circular'
  };
  
  if (duration !== undefined) {
    options.duration = duration;
  }
  
  const loading = await loadingController.create(options);

  await loading.present();

  return loading;
}

export async function hideLoading() {
  const isPresent = await loadingController.getTop();

  if (!isPresent) {
    return; 
  }

  await loadingController?.dismiss();

  isLoading.value = false;
}
